/* eslint-disable jira/filename-case */
export interface GlobalThisExtended {
	STICKY_VERSION_STATE?: string;
}
// eslint-disable-next-line no-shadow-restricted-names
declare const globalThis: GlobalThisExtended;

export const getStickyVersionsState = (): string => {
	const stickyVersionState = globalThis.STICKY_VERSION_STATE ?? 'na';

	return stickyVersionState;
};
